import { Component, HostBinding, input } from '@angular/core';
import type { CssColor } from '@appTypes';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [],
  templateUrl: './spinner.html',
  styleUrl: './spinner.scss',
})
export class Spinner {
  // Inputs
  $size = input<string>('16px', { alias: 'size' });
  $borderWidth = input<string>('3.5px', { alias: 'borderWidth' });
  $color = input<CssColor>('--spinner', { alias: 'color' });

  // Bindings
  @HostBinding('style.width')
  get hostWidth(): string { return this.$size(); }
  @HostBinding('style.height')
  get hostHeight(): string { return this.$size(); }
}
